import script from "./SsoCallback.vue?vue&type=script&setup=true&lang=ts"
export * from "./SsoCallback.vue?vue&type=script&setup=true&lang=ts"

import "./SsoCallback.vue?vue&type=style&index=0&id=374f2f70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374f2f70"]])

export default __exports__